import React, { useContext, useState } from 'react'
import { Modal } from 'react-bootstrap'
import "./ModalNewMuestra.scss"
import { muestraContext } from '../../../pages/Normas/Muestras'
import { NormasContext } from '../../../context/NormasContext'

function ModalVerificarMuestra(props) {

    const { user, idSubtarea, idVerificar } = useContext(muestraContext)
    const { fetchMuestras } = useContext(NormasContext)

    const [objVerificar, setObjVerificar] = useState({
        opcion: "",
        texto: ""
    })

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    const handleClose = () => {
        setObjVerificar({
            opcion: "",
            texto: ""
        })
        setModalErr(null)
        setErrors({})
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setObjVerificar(prev => ({
            ...prev,
            [name]: value
        }));
    }

    const handleSubmitVerificar = async (e) => {
        e.preventDefault()

        let errors = {}
        if(!objVerificar.opcion.trim()) {
            errors.opcion = "Marca una opción."
        }
        if(objVerificar.opcion === "2"){
            if(!objVerificar.texto.trim()) {
                errors.texto = "Escribe un texto breve."
            }
        }

        if(Object.keys(errors).length === 0){
            setErrors({})

            const obj = {
                user,
                idMuestra: parseInt(idVerificar),
                tipoResolucion: parseInt(objVerificar.opcion),
                ...(objVerificar.opcion === "2" && { texto: objVerificar.texto})
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/normas/evaluarMuestra`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.error ?? data.status
                if(errorCode !== 0){
                    setModalErr(data.codeError || data.errorDetalle)
                } else {
                    handleClose()
                    // actualizar muestras
                    fetchMuestras({
                        idsubtarea: idSubtarea
                    })
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            }
        } else {
            setErrors(errors)
        }
    }

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            className='modal__verificar'
            dialogClassName={props.dialogClassName}
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                    <h3 className='m-0'>Verificar evidencia</h3>
                    <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmitVerificar} className='d-flex flex-column align-items-center'>
                    <div className='w-100 d-flex flex-column mb-2'>
                        <div className='w-100 d-flex flex-row justify-content-between'>
                            <div className="w-50 form-check me-3">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="opcion" 
                                    value="1"
                                    checked={objVerificar.opcion === "1"}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="opcion">Aprobar</label>
                            </div>
                            <div className="w-50 form-check me-3">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="opcion" 
                                    value="2" 
                                    checked={objVerificar.opcion === "2"}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="opcion">Denegar</label>
                            </div>
                        </div>
                        {errors?.opcion && (
                            <span className='align-self-center text-danger mt-2'><i className="bi bi-exclamation-circle me-1"></i>{errors?.opcion}</span>
                        )}
                    </div>
                    {objVerificar.opcion === "2" && (
                        <div className='inputTextArea w-100 d-flex flex-column mb-2'>
                            <div className='w-100'>
                                <label className='mb-1 fw-semibold'>Texto explicativo</label>
                                <textarea 
                                    name="texto" 
                                    id="texto" 
                                    placeholder='Texto breve sobre el motivo por el que deniega la evidencia.'
                                    value={objVerificar.texto}
                                    onChange={handleChange}
                                    rows="4"
                                    className={`w-100 form-control border no-outline focus-ring ${
                                        errors?.evidencia ? "border-danger focus-ring-red" : "border-secondary-subtle focus-ring-blue"
                                    }`}
                                ></textarea>
                            </div>
                            {errors?.texto && (
                                <span className='align-self-center text-danger mt-2'><i className="bi bi-exclamation-circle me-1"></i>{errors?.texto}</span>
                            )}
                        </div>
                    )}
                    {modalErr !== null && <span className='align-self-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                    <button type='submit' className='btn btn-primary rounded-pill px-3 fw-medium'>Verificar evidencia</button>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default ModalVerificarMuestra